import { Address } from './address.model';
import { PhoneContact } from './phone-contact.model';

export class LCAAddNew {
    constructor(obj: Partial<LCAAddNew>) {
        Object.assign(this, obj);
    }
    id: number;
    isCertifiedLCA:boolean;
    caseNumber: string;
    visaType: string;
    jobTitle: string;
    socCode: string;
    onetSocVer: string;
    socTitle: string;
    isFullTime: boolean;
    empFullTime: string;
    employmentStartDate: string;
    employmentEndDate: string;
    totalCount: number;
    newEmploymentCount: number;
    continueApprovedCount: number;
    changeApproveCount: number;
    concurrentEmploymentCount: number;
    employerChangeCount: number;
    amendedPetitionCount: number;
    companyId: number;
    comment?: string;
    status?: any;
    company?: any;
    placeOfEmployments?: PlaceOfEmployment[];
    lcaAppliedDate?:string;
    certifiedDate?:string;
    workforceNotifiedDate?:string;
    sampleFileOne?:string;
    sampleFilePath?:string;
    sampleFileTwo?:string;
    isWorkforceNotified?:boolean;
    companyNaicsCode: string;
    companyNaicsTitle: string;
    // federalemployernumber: string;
    // naicscode: string;
    // phoneContact: PhoneContact ;
    // address?: Address[];
    lcaFiledType: string;

}

export interface PlaceOfEmployment {
    addressDTO: EmplmntAddress;
    wageRangeFrom: number;
    wageRangeTo: number;
    wageRangeTypeCode:string;
    prvlWageRate:number;
    prvWageTypeCode:string;
    prvWageLevelTypeCode:string;
    sequenceNo:number,
    id: number,
    lcaCodeId: number,
    countyAreaName?: string;
}

export interface EmplmntAddress {
    addressLine1:string;
    addressLine2 :string;
    city:string;
    county:string;
    stateProvinceName:string;
    postalCode:string;
    addressTypeCode:string,
    id:number,
    stateProvinceCode: string,

}

export interface LCAWithdraw {
    statusChangeReason: string;
    statusCode?: string;
    statusUpdatedDate: string;
}
